import pages from '@/app/cashflow/pages.js'

const cashFlowPages = new pages();

export default [
  {
    path: '/bsg/cashflow',
    name: 'BSG-Cashflow',
    component: () => import('@/app/cashflow/Cashflow.vue'),
    meta: {
      breadcrumb: [
        { title: 'Home', url: '/', i18n: 'Home' },
        { title: 'BSG',  url: '/bsg', i18n: 'BSG.Title' },
        { title: 'Cashflow', active: true, i18n: 'CashFlow.Title' }
      ],
      pageTitle: 'Cashflow',
      i18n: 'CashFlow.Title',
      rule: 'editor',
      requireAuth: true,
      requireRoles: [
        'CashflowReaders',
        'CashflowWriter',
        'Admin'
      ]
    }
  },
  {  
    path: '/bsg/cashflow/reports',
    name: 'BSG-cashflow-reports',
    component: () => import('@/app/geo/gradecontrol/reports/report.vue'),
    props: {
      groupId: 'CashFlowGroupId',
      reportId: 'CashFlow'
    },
    meta: {
      breadcrumb: [
        { title: 'Home', url: '/' },
        { title: 'BSG',  url: '/bsg', i18n: 'BSG.Title' },
        { title: 'Cashflow', url: '/bsg/cashflow', i18n: 'CashFlow.Title' },
        { title: 'Report', active: true, i18n: 'CashFlow.Reports.Title' }
      ],
      requireAuth: true,
      requireRoles: [
        'CashflowReaders',
        'CashflowWriter',
        'Admin'
      ],
      pageTitle: 'Reports',
      rule: 'editor',
      i18n: 'CashFlow.Reports.Title'
    }
  },
  {
    path: '/bsg/cashflow/admin',
    name: 'BSG-cashflow-admin',
    component: () => import('@/app/cashflow/admin/index.vue'),
    meta: {
      breadcrumb: [
        { title: 'Home', url: '/' },
        { title: 'BSG',  url: '/bsg', i18n: 'BSG.Title' },
        { title: 'Cashflow', url: '/bsg/cashflow', i18n: 'CashFlow.Title' },
        { title: 'Admin', active: true,  i18n: 'CashFlow.Admin.Title' }
      ],
      requireAuth: true,
      requireRoles: [
        'CashflowWriter',
        'Admin'
      ],
      pageTitle: 'Admin',
      rule: 'editor',
      i18n: 'CashFlow.Admin.Title'
    }
  },
  {
    path: '/bsg/cashflow/admin/Regions',
    name: 'BSG-cashflow-admin-regions',
    component: () => import('@/app/cashflow/admin/regions/index.vue'),
    meta: {
      breadcrumb: [
        { title: 'Home', url: '/' },
        { title: 'BSG',  url: '/bsg', i18n: 'BSG.Title' },
        { title: 'Cashflow', url: '/bsg/cashflow', i18n: 'CashFlow.Title'},
        { title: 'Admin', url: '/bsg/cashflow/admin', i18n: 'CashFlow.Admin.Title'},
        { title: 'Regions', active: true, i18n: 'CashFlow.Region.Title'}
      ],
      pageTitle: 'Regions',
      i18n: 'CashFlow.Region.Title',
      rule: 'editor',
      requireAuth: true,
      requireRoles: [
        'CashflowWriter',
        'Admin'
      ]
    }
  },
  {
    path: '/bsg/cashflow/admin/Projects',
    name: 'BSG-cashflow-admin-projects',
    component: () => import('@/app/cashflow/admin/projects/index.vue'),
    meta: {
      breadcrumb: [
        { title: 'Home', url: '/' },
        { title: 'BSG',  url: '/bsg', i18n: 'BSG.Title' },
        { title: 'Cashflow', url: '/bsg/cashflow', i18n: 'CashFlow.Title'},
        { title: 'Admin', url: '/bsg/cashflow/admin', i18n: 'CashFlow.Admin.Title'},
        { title: 'Projects', active: true, i18n: 'CashFlow.Project.Title' }
      ],
      pageTitle: 'Projects',
      i18n: 'CashFlow.Project.Title',
      rule: 'editor',
      requireAuth: true,
      requireRoles: [
        'CashflowWriter',
        'Admin'
      ]
    }
  },
  {
    path: '/bsg/cashflow/projectLoms',
    name: 'BSG-cashflow-projectLoms',
    component: () => import('@/app/cashflow/projectLoms/index.vue'),
    meta: {
      breadcrumb: [
        { title: 'Home', url: '/' },
        { title: 'BSG',  url: '/bsg', i18n: 'BSG.Title' },
        { title: 'Cashflow', url: '/bsg/cashflow', i18n: 'CashFlow.Title'},
        { title: 'ProjectLoms', active: true, i18n: 'CashFlow.ProjectLom.Title' }
      ],
      pageTitle: 'ProjectLoms',
      i18n: 'CashFlow.ProjectLom.Title',
      rule: 'editor',
      requireAuth: true,
      requireRoles: [
        'CashflowWriter',
        'Admin'
      ]
    }
  },
  {
    path: '/bsg/cashflow/corporateLoms',
    name: 'BSG-cashflow-corporateLoms',
    component: () => import('@/app/cashflow/corporateLoms/index.vue'),
    meta: {
      breadcrumb: [
        { title: 'Home', url: '/' },
        { title: 'BSG',  url: '/bsg', i18n: 'BSG.Title' },
        { title: 'Cashflow', url: '/bsg/cashflow', i18n: 'CashFlow.Title'},
        { title: 'CorporateLoms', active: true, i18n: 'CashFlow.CorporateLom.Title' }
      ],
      pageTitle: 'CorporateLoms',
      i18n: 'CashFlow.CorporateLom.Title',
      rule: 'editor',
      requireAuth: true,
      requireRoles: [
        'CashflowWriter',
        'Admin'
      ]
    }
  },
  {
    path: '/bsg/cashflow/compilations',
    name: 'BSG-cashflow-compilations',
    component: () => import('@/app/cashflow/compilations/index.vue'),
    meta: {
      breadcrumb: [
        { title: 'Home', url: '/' },
        { title: 'BSG',  url: '/bsg', i18n: 'BSG.Title' },
        { title: 'Cashflow', url: '/bsg/cashflow', i18n: 'CashFlow.Title'},
        { title: 'Compilations', active: true, i18n: 'CashFlow.Compilation.Title' }
      ],
      pageTitle: 'Compilations',
      i18n: 'CashFlow.Compilation.Title',
      rule: 'editor',
      requireAuth: true,
      requireRoles: [
        'CashflowWriter',
        'Admin'
      ]
    }
  },
  {
    path: '/bsg/cashflow/compilations/compilationEdit',
    name: 'BSG-cashflow-compilations-compilationEdit',
    component: () => import('@/app/cashflow/compilations/compilationEdit.vue'),
    meta: {
      breadcrumb: [
        { title: 'Home', url: '/' },
        { title: 'BSG',  url: '/bsg', i18n: 'BSG.Title' },
        { title: 'Cashflow', url: '/bsg/cashflow', i18n: 'CashFlow.Title'},
        { title: 'Compilations', url: '/bsg/cashflow/compilations', i18n: 'CashFlow.Compilation.Title' },
        { title: 'CompilationsEdit', active: true, i18n: 'CashFlow.Compilation.Edit' }
      ],
      pageTitle: 'CompilationEdit',
      i18n: 'CashFlow.Compilation.Edit',
      rule: 'editor',
      requireAuth: true,
      requireRoles: [
        'CashflowWriter',
        'Admin'
      ]
    }
  },
  {
    path: '/bsg/cashflow/reports/compilation',
    name: 'BSG-cashflow-reports-compilation',
    component: () => import('@/app/cashflow/reports/compilation.vue'),
    meta: {
      breadcrumb: [
        { title: 'Home', url: '/' },
        { title: 'BSG',  url: '/bsg', i18n: 'BSG.Title' },
        { title: 'Cashflow', url: '/bsg/cashflow', i18n: 'CashFlow.Title' },
        { title: 'Compilations', url: '/bsg/cashflow/compilations', i18n: 'CashFlow.Compilation.Title' },
        { title: 'CompilationReport', active: true, i18n: 'CashFlow.Compilation.Report' }
      ],
      requireAuth: true,
      requireRoles: [
        'CashflowReaders',
        'CashflowWriter',
        'Admin'
      ],
      pageTitle: 'Compilation Report',
      i18n: 'CashFlow.Compilation.Report'     
    }
  },

  ...cashFlowPages.getRoutes()
]